<div class="ti-custom-tooltip " [ngClass]="{'ti-custom-tooltip--hidden': hidden}">
  <a class="ti-link-underline-text-decoration" *ngIf="link" (click)="goToUrl()">{{link.text}}</a>
</div>
